import { Dialog, Transition, TransitionChild, DialogPanel, DialogTitle, Button } from '@headlessui/react'
import { forwardRef, useImperativeHandle, useState } from "react";

const Alert = forwardRef((props, ref) => {
    let [isOpen, setIsOpen] = useState(false)

    function close () {
        setIsOpen(false)
    }

   
    useImperativeHandle(ref, () => ({
        toggleState () {
            setIsOpen(!isOpen)
          }
    }));


    return (
        <>
            <Transition appear show={isOpen}>
                <Dialog as="div" className="relative z-10 focus:outline-none" onClose={close}>
                <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                    <TransitionChild
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 transform-[scale(95%)]"
                        enterTo="opacity-100 transform-[scale(100%)]"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 transform-[scale(100%)]"
                        leaveTo="opacity-0 transform-[scale(95%)]"
                    >
                        <DialogPanel className="w-full max-w-lg p-7 bg-white backdrop-blur-2xl">
                            <DialogTitle as="h3" className=" text-center text-sm font-medium text-gray-600">
                                Message
                            </DialogTitle>
                            <div>
                                <p className=" text-center text-size text-gray-600 mt-2">
                                    {props.message}
                                </p>
                            </div>
                            <div className='mx-auto mt-4 flex items-center'>
                                <Button
                                    className="inline-flex rounded-2xl items-center mx-auto bg-[#1C1C1C] py-1.5 px-3 text-size font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-gray-600 data-[open]:bg-gray-700 data-[focus]:outline-1 data-[focus]:outline-white"
                                    onClick={close}
                                    >
                                    Cancel
                                </Button>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                    </div>
                </div>
                </Dialog>
            </Transition>
        </>
    );
})

export default Alert;